import React from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import NewItem from "./NewItem";

const Index = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [items, setItems] = useState([
    {
      id: Math.random(),
      product_name: "",
      quantity: "",
      net_price: "",
      total_price: "",
    },
  ]);

  const onSubmit = (data) => {
    console.log({ ...data, items });
  };

  const handleRemove = (id) => {
    const filter = items.filter((it) => it.id !== id);
    setItems(filter);
  };

  return (
    <div className="w-10/12 mx-auto my-5">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex justify-between items-center flex-col sm:flex-row">
          <h1 className="text-3xl">Purchase</h1>
          <input
            type="submit"
            value="Save & Get Invoice"
            className="btn btn-active text-white rounded-none mt-5 sm:mt-0 w-full sm:w-auto"
          />
          {/* Save & Get Invoice
          </input> */}
        </div>
        <div>
          <div>
            <div className="grid gird-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                id="supplier_name"
                placeholder="Supplier Name*"
                className={
                  errors.supplier_name
                    ? "input input-error w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm mt-5"
                    : "input input-bordered w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm mt-5"
                }
                {...register("supplier_name", {
                  required: {
                    value: true,
                    message: "*Required",
                  },
                  validate: (val) => {
                    return val.trim() !== "" || "*Required";
                  },
                })}
                required
              />
              <input
                type="text"
                id="supplier_phone"
                placeholder="Supplier Phone Number*"
                className={
                  errors.supplier_phone
                    ? "input input-error w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm md:mt-5 mt-0"
                    : "input input-bordered w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm md:mt-5 mt-0"
                }
                {...register("supplier_phone", {
                  required: {
                    value: true,
                    message: "*Required",
                  },
                  validate: (val) => {
                    return val.trim() !== "" || "*Required";
                  },
                })}
                required
              />
            </div>
            <input
              type="text"
              id="supplier_address"
              placeholder="Supplier Address*"
              className={
                errors.supplier_address
                  ? "input input-error w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm mt-5"
                  : "input input-bordered w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm mt-5"
              }
              {...register("supplier_address", {
                required: {
                  value: true,
                  message: "*Required",
                },
                validate: (val) => {
                  return val.trim() !== "" || "*Required";
                },
              })}
              required
            />
          </div>
          <div className="">
            {items.map((item, index) => {
              return (
                <NewItem
                  index={index}
                  key={item.id}
                  item={item}
                  setItems={setItems}
                  handleRemove={handleRemove}
                />
              );
            })}
          </div>
          <a
            href="##"
            onClick={() => {
              setItems([...items, { id: Math.random() }]);
            }}
            className="btn btn-success text-white rounded-none mt-5 w-full text-center flex items-center"
          >
            <i className="fa-solid fa-plus mr-2"></i> New Item
          </a>
        </div>
      </form>
    </div>
  );
};

export default Index;
